export const columns = [
  { name: "Status", uid: "status", sortable: true },
  { name: "Customer", uid: "customer", sortable: true },
  { name: "Company", uid: "company", sortable: true },
  { name: "Car", uid: "car", sortable: true },
  { name: "Quantity", uid: "quantity", sortable: true },
  { name: "Total Price (Inc. GST)", uid: "total price", sortable: true },
  { name: "Created", uid: "created", sortable: true },
];

export const statusOptions = [
  { name: "all", uid: "all" },
  { name: "Awaiting Approval", uid: "awaiting approval" },
  { name: "progress", uid: "progress" },
  { name: "accepted", uid: "accepted" },
];

export const chipstyle = {
  1: "primary",
  2: "warning",
  3: "secondary",
  4: "success",
  5: "success",
  6: "success",
  7: "danger",
  8: "danger",
};
export const chipClassNames = {
  // primary: "text-blue-400 font-semibold border-blue-400",
  // warning: "text-yellow-400 font-semibold border-yellow-400",
  // success: "text-green-400 font-semibold border-green-400",
  danger: "text-red-400 font-bold border-red-400",
};
